// God's-eye Contact column registry.
export const CONTACT_COLUMNS = [
  { key: 'id',                 label: 'ID',            render: 'id',        width: 64,  frozen: true, sort: 'id' },
  { key: 'name',               label: 'Name',          render: 'name',      width: 180, frozen: true, editable: true, sort: 'full_name' },
  { key: 'contact_types',      label: 'Contact type',  render: 'types',     width: 170, editable: true },
  { key: 'score',              label: 'Score',         render: 'score',     width: 70, sort: 'score' },
  { key: 'company_name',       label: 'Company',       render: 'company',   width: 190, sort: 'company.name' },
  { key: 'job_title',          label: 'Job title',     render: 'text',      width: 170, editable: true, sort: 'job_title' },
  { key: 'email_seq',          label: 'Email seq',     render: 'seqcount',  width: 110 },
  { key: 'linkedin_seq',       label: 'LinkedIn seq',  render: 'seqcount',  width: 110 },
  { key: 'signal_types',       label: 'Signals',       render: 'signals',   width: 150 },
  { key: 'email',              label: 'Email',         render: 'email',     width: 210, editable: true, sort: 'email' },
  { key: 'phone',              label: 'Phone',         render: 'text',      width: 140, editable: true },
  { key: 'linkedin_url',       label: 'LinkedIn',      render: 'link',      width: 110, editable: true },
  { key: 'last_sent_at',       label: 'Last sent',     render: 'date',      width: 110, sort: 'last_emailed' },
  { key: 'last_open_at',       label: 'Last opened',   render: 'date',      width: 110, sort: 'last_opened' },
  { key: 'opted_out',          label: 'Opted out',     render: 'optout',    width: 100 },
  { key: 'campaign_name',      label: 'Campaign',      render: 'campaign_pill', width: 150 },
  { key: 'email_batches',      label: 'Email batch',   render: 'batches',   width: 150 },
  { key: 'linkedin_batches',   label: 'LinkedIn batch',render: 'batches',   width: 150 },
  { key: 'status',             label: 'Status',        render: 'status',    width: 110, editable: true, sort: 'status' },
  { key: 'enriched',           label: 'Enriched',      render: 'bool',      width: 90 },
  { key: 'created_at',         label: 'Created',       render: 'ukdate',    width: 110, sort: 'created_at' },
  { key: 'updated_at',         label: 'Modified',      render: 'ukdate',    width: 110, sort: 'updated_at' },
];

export const CONTACT_COLUMNS_EXTRA = [
  { key: 'first_name',     label: 'First name',    render: 'text',  width: 130, editable: true },
  { key: 'last_name',      label: 'Last name',     render: 'text',  width: 130, editable: true },
  { key: 'location',       label: 'Location',      render: 'text',  width: 150 },
  { key: 'sector',         label: 'Sector',        render: 'sectors', width: 160 },
  { key: 'size',           label: 'Company size',  render: 'text',  width: 120 },
  { key: 'icp_score',      label: 'ICP fit',       render: 'score', width: 80 },
  { key: 'signal_score',   label: 'Signal score',  render: 'score', width: 90 },
  { key: 'sequence_sets',  label: 'Sequence sets', render: 'number',width: 110 },
  { key: 'campaign_step',  label: 'Campaign step', render: 'number',width: 110 },
  { key: 'replied_at',     label: 'Replied',       render: 'ukdate',width: 110 },
  { key: 'bounced_at',     label: 'Bounced',       render: 'ukdate',width: 110 },
  { key: 'email_verification_result', label: 'Email check', render: 'text', width: 120 },
  { key: 'enriched_at',    label: 'Enriched date', render: 'ukdate',width: 120 },
  { key: 'crm_push_target',label: 'CRM dest',      render: 'text',  width: 120 },
  { key: 'crm_push_status',label: 'CRM sync',      render: 'crm',   width: 110 },
];

export const ALL_CONTACT_COLUMNS = [...CONTACT_COLUMNS, ...CONTACT_COLUMNS_EXTRA];

// God's-eye Company column registry.
export const COMPANY_COLUMNS = [
  { key: 'id',            label: 'ID',          render: 'id',          width: 64,  frozen: true, sort: 'id' },
  { key: 'name',          label: 'Company',     render: 'companyname', width: 220, frozen: true, sort: 'name' },
  { key: 'contact_count', label: 'Contacts',    render: 'countpill',   width: 100, sort: 'contact_count' },
  { key: 'score',         label: 'Score',       render: 'score',       width: 70,  sort: 'fit_score' },
  { key: 'signal_types',  label: 'Signals',     render: 'signals',     width: 160 },
  { key: 'sector',        label: 'Sector',      render: 'sectors',     width: 160, sort: 'sector' },
  { key: 'size',          label: 'Size',        render: 'text',        width: 110, sort: 'size' },
  { key: 'location',      label: 'Location',    render: 'text',        width: 150, sort: 'location' },
  { key: 'website',       label: 'Website',     render: 'link',        width: 120 },
  { key: 'sweep',         label: 'Signal scan', render: 'sweep',       width: 130 },
  { key: 'in_campaign_count', label: 'In campaign', render: 'countpill', width: 110 },
  { key: 'notes_count',   label: 'Notes',       render: 'number',      width: 80 },
  { key: 'created_at',    label: 'Created',     render: 'ukdate',      width: 110, sort: 'created_at' },
  { key: 'updated_at',    label: 'Modified',    render: 'ukdate',      width: 110, sort: 'updated_at' },
];

export const COMPANY_COLUMNS_EXTRA = [
  { key: 'fit_score',     label: 'Fit score',   render: 'score',  width: 90,  sort: 'fit_score' },
  { key: 'revenue',       label: 'Revenue',     render: 'text',   width: 120 },
  { key: 'keywords',      label: 'Keywords',    render: 'text',   width: 200 },
  { key: 'linkedin_url',  label: 'LinkedIn',    render: 'link',   width: 110 },
  { key: 'status',        label: 'Status',      render: 'status', width: 110, sort: 'status' },
  { key: 'source',        label: 'Source',      render: 'text',   width: 110 },
  { key: 'signal_count',  label: 'Signal count',render: 'number', width: 110 },
  { key: 'avg_score',     label: 'Avg score',   render: 'score',  width: 90 },
  { key: 'last_swept_at', label: 'Last scanned',render: 'ukdate', width: 120, sort: 'swept_at' },
  { key: 'next_sweep_due',label: 'Next scan due',render: 'ukdate',width: 120 },
  { key: 'description',   label: 'Description', render: 'text',   width: 240 },
];

export const ALL_COMPANY_COLUMNS = [...COMPANY_COLUMNS, ...COMPANY_COLUMNS_EXTRA];
